import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfirmationService, MessageService } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ActividadService } from '../../../../services/database/actividad.service';
import { ActividadDto, VwActividad } from '../../../../shared/interfaces/database/configuracion';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SecPermisoService } from '../../../../services/database/secPermiso.service';
import { ISecPermiso } from '../../../../shared/interfaces/database/seguridad';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormGroupErrorMessageComponent, LocalService, noWhitespaceValidator, AccessRole, Utils, CustomTitle, CustomTableComponent, ICustomTable, IHeader, DataColumnType, ButtonColumnType, LoadingPanelService } from 'lib-base';
import { CheckboxModule } from 'primeng/checkbox';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { AdminActividadesHistoricoComponent } from './admin-actividades-historico/admin-actividades-historico.component';

@Component({
  selector: 'app-admin-actividades',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule, TranslateModule, CustomTableComponent, AdminActividadesHistoricoComponent,
    TableModule, ButtonModule, ConfirmPopupModule, DialogModule, DropdownModule, InputTextModule, InputNumberModule, CheckboxModule,
    FormGroupErrorMessageComponent, CustomTitle
  ],
  providers: [ConfirmationService],
  templateUrl: './admin-actividades.component.html',
  styleUrls: ['./admin-actividades.component.scss']
})
export class AdminActividadesComponent implements OnInit {
  formTitle = '';
  displayModal = false;
  actividadesForm !: FormGroup;
  permisos !: ISecPermiso[];
  private _editActividadId !: VwActividad | undefined;

  role = AccessRole;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(AdminActividadesHistoricoComponent) historico !: AdminActividadesHistoricoComponent;
  private originalValues: any;

  constructor(private readonly _as: ActividadService, private readonly _sp: SecPermisoService, private readonly _fb: FormBuilder, private readonly _t: TranslateService,
    private readonly _ms: MessageService, private readonly _cs: ConfirmationService, public ls: LocalService, private readonly _lps: LoadingPanelService) {
    this.configureNewAcitividadesForm();
  }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      requiereRolSeguridad: this._t.get('msg.requiereRolSeguridad'),
      actividadActualizada: this._t.get('msg.actividadActualizada'),
      actividadCreada: this._t.get('msg.actividadCreada'),
      actividadEliminada: this._t.get('msg.actividadEliminada'),
      advertenciaCompletarCampos: this._t.get('msg.advertenciaCompletarCampos'),
      codificacion: this._t.get('common.codificacion'),
      descripcion: this._t.get('common.descripcion'),
      manual: this._t.get('common.manual'),
      permiso: this._t.get('common.permiso'),
      exito: this._t.get('common.exito'),
      advertencia: this._t.get('common.advertencia'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
    }));

    this.customTable = {
      dataKey: 'actividadId',
      header: {
      } as IHeader,
      columns: [
        {
          field: 'actividadCodificacion',
          header: this.trans.codificacion,
          sort: true,  class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'actividadDescripcion',
          header: this.trans.descripcion,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'actividadManual',
          header: this.trans.manual,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          dataType: DataColumnType.CHECK
        },
        {
          field: 'permisoCodificacion',
          header: this.trans.permiso,
          sort: true,
          class:'font-13',
          columnmHeader: {
            class:'text-left color-blue-2 font-13 font-bold',
            style:''
          },
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'abrir',
          header: '',
          icon: 'pi pi-history',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0',
          width: '0rem',
          severity: 'info',
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: VwActividad) => this.abrirHistorial(data),
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-1 pr-1',
          buttonType: ButtonColumnType.EDIT,
          disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: VwActividad) => this.openEditModal(data),
          headerBtn: {
            icon: 'pi pi-history',
            class: 'pt-2 pb-2 pl-0 pr-0',
            severity: 'info',
            onClick: (event: Event) => this.abrirHistorialEliminado(),
          }
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          tooltip: {
            message: this.trans.requiereRolSeguridad
          },
          onClick: (event: Event, data: VwActividad) => this.deleteConfirmation(event, data),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-0 pr-0',
            onClick: (event: Event) => this.openNewModal(),
            disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          },
          headerTooltip:{
            message: this.trans.requiereRolSeguridad,
            disabled: this.ls.hasRole(this.role.ADMIN_TRAM)
          }
        }
      ],
      settings: {
        table: {
          rows: 7,
        }
      }
    } as ICustomTable;
  }

  get isNewForm(): boolean {
    return this._editActividadId === undefined;
  }

  configureNewAcitividadesForm() {
    this.actividadesForm = this._fb.group({
      permisoId: [null, [Validators.required]],
      codificacion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(20)]],
      descripcion: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(100)]],
      manual: [0, [Validators.required, Validators.min(0)]]
    });
  }

  openNewModal() {
    this.formTitle = 'Nueva Actividad';
    this._editActividadId = undefined;
    this.resetForm();
    this.actividadesForm.get('manual')?.setValue(0);
    this.getPermisos();
    this.displayModal = true;
  }

  openEditModal(actividad: VwActividad) {
    this.resetForm();
    this.formTitle = 'Editar Actividad';
    this._editActividadId = actividad;
    this.actividadesForm.get('permisoId')?.setValue(actividad.permisoId);
    this.actividadesForm.get('codificacion')?.setValue(actividad.actividadCodificacion);
    this.actividadesForm.get('descripcion')?.setValue(actividad.actividadDescripcion);
    this.actividadesForm.get('manual')?.setValue(actividad.actividadManual);
    this.getPermisos();
    this.displayModal = true;
    this.originalValues = { ...this.actividadesForm.value };
  }

  onSubmit() {
    if (this.actividadesForm.pristine) {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
      return;
    }

    if (this.actividadesForm.invalid) {
      Utils.markAllFormControlsAsTouched(this.actividadesForm);
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario  });
      return;
    }

    const newValues = {
      permisoId: this.actividadesForm.get('permisoId')?.value,
      codificacion: this.actividadesForm.get('codificacion')?.value,
      descripcion: this.actividadesForm.get('descripcion')?.value,
      manual: this.actividadesForm.get('manual')?.value
    } as ActividadDto;

    if (this.isNewForm) {
      this.createActividad(newValues);
    } else if (!Utils.isDeepEqual(this.originalValues, newValues)) {
      this.updateActividad(newValues);
    } else {
      this._ms.add({ severity: 'warn', summary: this.trans.advertencia, detail: this.trans.noCambiosFormulario });
    }
  }

  resetForm() {
    this.actividadesForm.reset();
  }

  deleteConfirmation(event: Event, data: VwActividad) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: 'Estas seguro de que quieres eliminar la actividad?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteActividad(data.actividadId);
      },
      reject: () => {

      }
    });
  }

  abrirHistorial(data: VwActividad): void {
    this.historico.show(data.actividadId);
  }

  abrirHistorialEliminado(): void {
    this.historico.showEliminado();
  }
  //#region API Calls
  getActividades() {
    this._as.getActividades().subscribe({
      next: (data: VwActividad[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  getPermisos() {
    this._sp.getSecPermisosByTipo('TRAMITE').subscribe({
      next: (response: ISecPermiso[]) => {
        this.permisos = response;
      }
    });
  }

  updateActividad(actividad: ActividadDto) {
    if (!this._editActividadId) return;
    this._lps.show(true);
    this._as.updateActividad(this._editActividadId.actividadId, actividad).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: 'Éxito', detail: this.trans.actividadActualizada });
        this.getActividades();
        this.displayModal = false;
      }
    });
  }

  createActividad(actividad: ActividadDto) {
    this._lps.show(true);
    this._as.createActividad(actividad).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: 'Éxito', detail: this.trans.actividadCreada });
        this.getActividades();
        this.displayModal = false;
      },
    });
  }

  deleteActividad(actividadId: number) {
    this._lps.show(true);
    this._as.deleteActividad(actividadId).subscribe({
      next: (response: string) => {
        this._lps.hide();
        this._ms.add({ severity: 'success', summary: 'Éxito', detail: this.trans.actividadEliminada });
        this.getActividades();
      }
    });
  }
  //#endregion API Calls
}
